// extracted by mini-css-extract-plugin
export default {"button":"xOsOg","buttonIcon":"aAmlk"};